import React, { lazy, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast from "../../Hooks/useToast";
import CustomBadge from "../Badges/CustomBadge.js";
import DetailRow from "../CustomComponents/DetailRow";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

// const ZoomImage = lazy(() => import("../ZoomImage.js"));

// import {
//   addServiceMutation,
//   useUpdServiceMutation,
// } from "../../Data/services/businessTypeApi";

const OrderDetailsModal = ({ handleEditModalClose, editData, refetch }) => {
  console.log(editData);
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      question: editData ? editData.question : "",
      short_answer: editData ? editData.short_answer : "",
      points: editData ? editData.points : "",
    },
  });

  const [rowId, setRowId] = useState("");
  const [category, setCategory] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [categoryList, setCategoryList] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleBusinessTitle = (e) => {
    // console.log(e.target.value);
    setCategory(e.target.value);
  };

  // const handleImage = (e) => {
  //   console.log(e.target.files[0]);
  //   setImage(e.target.files[0]);
  // };

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">{"Order Details"}</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>

          <table className="w-100">
            <thead>
              <tr>
                <th>Product</th>
                <th className="text-center">Variants</th>
                <th className="text-center">Quantity</th>
                <th className="text-center">Price</th>
              </tr>
            </thead>
            <tbody>
              {editData?.items?.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{item?.item_product?.name}</td>
                    <td className="text-center" style={{ maxWidth: "100px" }}>
                      <div className="d-flex align-items-center flex-row flex-wrap gap-3">
                        {item?.order_item_variants?.map((variant, j) => {
                          return (
                            // <tr style={{ borderRadius: "0px" }}>
                            //   <td>{variant.name}</td>
                            //   <td>{variant.value}</td>
                            //   <td>{variant.price}</td>
                            // </tr>
                            <div
                              className="d-flex flex-row gap-2 w-100 justify-content-between bg-dark-subtle rounded-2 px-1 "
                              key={j}
                            >
                              <span>{variant?.name}</span>
                              <span>{variant?.value}</span>
                              <span>$ {variant?.price}</span>
                            </div>
                          );
                        })}
                      </div>
                    </td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-center">$ {item.price}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br></br>

          <Row className="w-100">
            <Col md={6} sm={12}>
              {/* <div className="text-center">
                <img
                  style={{ aspectRatio: 1 }}
                  alt=""
                  src={editData?.image_url}
                  className="rounded-circle mb-3"
                  width={"100px"}
                />
              </div> */}
              <DetailRow
                title={"Name"}
                value={`${editData?.user?.firstname} ${editData?.user?.lastname}`}
              />
              <DetailRow title={"Email"} value={editData?.user?.email} />
              <DetailRow title={"Phone"} value={editData?.user?.mobile_no} />
              <DetailRow
                title={"Address"}
                value={editData?.delivery_location}
              />
            </Col>

            <Col md={6} sm={12}>
              <DetailRow
                title={"Delivery Charges"}
                value={`$ ${editData?.delivery_charges}`}
              />
              <DetailRow
                title={"Platform Fee"}
                value={`$ ${editData?.platform_fee}`}
              />
              <DetailRow
                title={"Sub Total"}
                value={`$ ${editData?.sub_total}`}
              />
              <DetailRow
                title={"Total Amount"}
                value={`$ ${editData?.total_amount}`}
              />
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default OrderDetailsModal;
